// extracted by mini-css-extract-plugin
var _1 = "t2KG";
var _2 = "t2KH";
var _3 = "t2KI";
var _4 = "t2KJ";
export { _1 as "accordion", _2 as "asterix", _3 as "container", _4 as "label" }
